import { render, staticRenderFns } from "./AtomSidebarTitle.vue?vue&type=template&id=6f94fdf3&scoped=true&"
import script from "./AtomSidebarTitle.vue?vue&type=script&lang=js&"
export * from "./AtomSidebarTitle.vue?vue&type=script&lang=js&"
import style0 from "./AtomSidebarTitle.vue?vue&type=style&index=0&id=6f94fdf3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f94fdf3",
  null
  
)

export default component.exports